// NOTE: Gulp will join all files inside "js" folder and bundle evertyhing into one file

// enable tooltips
$('[data-toggle="tooltip"]').tooltip();